export { useReactForm } from './useReactForm2.js';

/**
 * @description EmptyValidationMessage should be empty space as yup is not recognize empty string.
 */
const EmptyValidationMessage = ' ';

export { EmptyValidationMessage };
